import React from 'react';
import {useAuthContext} from "store/auth";
import {Navigate, useLocation} from "react-router-dom";

function PrivateRouteComponent({component:Component}:{component: React.FC }) {
    const location = useLocation();
    const [{isLoggedIn}] = useAuthContext();

    if(!isLoggedIn) return <Navigate to={`/login?return-url=${location.pathname}`} />;
    return (
        <Component />
    );
}

export default PrivateRouteComponent;